// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__35A4T","list":"PatternAutocomplete_list__13961"};